import React from 'react';
import PageBuilderNavigationBar from '@/components/PageBuilderNavigationBar';
import leftImg from '@/assets/images/point/icon-left.png';
import styles from './index.less';

function NavigationBar(props) {
  return (
    <PageBuilderNavigationBar
      {...props}
      styles={styles}
      defaultBackIcon={leftImg}
      titleBoldWeight={700}
    />
  );
}

export default NavigationBar;
